<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="950px"
    @close="handleClose">
    <div slot="title">
      <p style="text-align: center; margin: 0;">
        <i class="el-icon-message" style="color: #ed624d; font-size: 18px; margin-right: 8px;"></i>
        通知
        <span v-if="notifyList && notifyList.length > 0" style="margin-left: 10px; font-size: 14px; color: #909399;">
          ({{ localCurrentIndex + 1 }}/{{ notifyList.length }})
        </span>
      </p>
    </div>
    <div class="notify-content">
      <template v-if="detail || notifyDetail">
        <h2 v-if="(detail || notifyDetail).title">{{ (detail || notifyDetail).title }}</h2>
        <div v-if="(detail || notifyDetail).publisher">
          <span>{{ (detail || notifyDetail).publisher }}</span>
          <span style="color: rgb(204, 204, 204); margin-left: 20px">
            {{ (detail || notifyDetail).createTime }}
          </span>
        </div>
        <div v-if="(detail || notifyDetail).content" v-html="(detail || notifyDetail).content"></div>
        <div v-else style="color: #909399; text-align: center; padding: 20px;">
          暂无内容
        </div>
      </template>
      <div v-else style="color: #909399; text-align: center; padding: 20px;">
        暂无数据
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="notifyList && notifyList.length > 0" type="primary" @click="handleConfirm">确认</el-button>
      <el-button v-if="hasPrev" @click="handlePrev">上一条</el-button>
      <el-button v-if="hasNext" type="primary" @click="handleNext">下一条</el-button>
      <el-button @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { confirmNotify, batchConfirmNotifies } from '@/api/notify'

export default {
  name: 'NotifyDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    notifyDetail: {
      type: Object,
      default: null
    },
    notifyList: {
      type: Array,
      default: () => []
    },
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      detail: null,
      localCurrentIndex: 0
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    hasNext() {
      if (!this.notifyList || this.notifyList.length === 0) {
        return false
      }
      return this.localCurrentIndex < this.notifyList.length - 1
    },
    hasPrev() {
      if (!this.notifyList || this.notifyList.length === 0) {
        return false
      }
      return this.localCurrentIndex > 0
    },
    currentNotify() {
      if (!this.notifyList || this.notifyList.length === 0) {
        return null
      }
      return this.notifyList[this.localCurrentIndex] || null
    }
  },
  mounted() {
    // 组件挂载时，如果已经可见且有数据，立即加载
    if (this.visible) {
      this.initData()
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initData()
      } else {
        // 关闭时清空数据
        this.detail = null
        this.localCurrentIndex = 0
      }
    },
    currentIndex(newVal) {
      this.localCurrentIndex = newVal
      if (this.visible && this.notifyList && this.notifyList.length > 0) {
        this.loadCurrentNotify()
      }
    },
    notifyList: {
      handler(newVal) {
        if (this.visible && newVal && newVal.length > 0) {
          // 同步 currentIndex
          this.localCurrentIndex = this.currentIndex
          // 确保索引在有效范围内
          if (this.localCurrentIndex >= newVal.length) {
            this.localCurrentIndex = newVal.length - 1
          }
          this.loadCurrentNotify()
        }
      },
      deep: true
    },
    currentNotify: {
      handler(newVal) {
        if (this.visible && newVal) {
          this.loadCurrentNotify()
        }
      },
      immediate: false
    },
    notifyDetail: {
      handler(newVal) {
        if (this.visible && newVal && (!this.notifyList || this.notifyList.length === 0)) {
          this.detail = { ...newVal }
          if (this.detail.createTime) {
            this.detail.createTime = this.formatDateTime(this.detail.createTime)
          }
        }
      },
      immediate: false
    }
  },
  methods: {
    initData() {
      // 同步索引
      this.localCurrentIndex = this.currentIndex

      if (this.notifyList && this.notifyList.length > 0) {
        // 如果有通知列表，使用列表中的当前项
        this.loadCurrentNotify()
      } else if (this.notifyDetail) {
        // 或者直接使用 notifyDetail
        this.detail = { ...this.notifyDetail }
        if (this.detail.createTime) {
          this.detail.createTime = this.formatDateTime(this.detail.createTime)
        }
      }
    },
    loadCurrentNotify() {
      if (!this.notifyList || this.notifyList.length === 0) {
        return
      }
      // 确保索引在有效范围内
      if (this.localCurrentIndex < 0) {
        this.localCurrentIndex = 0
      }
      if (this.localCurrentIndex >= this.notifyList.length) {
        this.localCurrentIndex = this.notifyList.length - 1
      }
      // 直接从 notifyList 获取当前项
      const currentNotify = this.notifyList[this.localCurrentIndex]
      if (!currentNotify) {
        console.warn('loadCurrentNotify: currentNotify 不存在', {
          localCurrentIndex: this.localCurrentIndex,
          listLength: this.notifyList.length,
          list: this.notifyList
        })
        return
      }
      // 直接使用 notifyList 中的数据，不需要二次加载
      this.detail = { ...currentNotify }
      if (this.detail.createTime) {
        this.detail.createTime = this.formatDateTime(this.detail.createTime)
      }
      console.log('loadCurrentNotify: 加载完成', {
        detail: this.detail,
        localCurrentIndex: this.localCurrentIndex
      })
    },
    async handleConfirm() {
      if (!this.currentNotify) {
        return
      }
      try {
        if (this.currentNotify.isMerged && this.currentNotify.mergedIds && this.currentNotify.mergedIds.length) {
          await batchConfirmNotifies(this.currentNotify.mergedIds)
        } else {
          await confirmNotify(this.currentNotify.id)
        }
        this.$message.success('确认成功')
        this.$emit('confirmed', this.currentNotify.id)
      } catch (error) {
        this.$message.error('确认失败: ' + (error.message || '未知错误'))
      }
    },
    handleNext() {
      if (this.hasNext) {
        this.localCurrentIndex++
        this.$emit('update:currentIndex', this.localCurrentIndex)
        this.loadCurrentNotify()
      }
    },
    handlePrev() {
      if (this.hasPrev) {
        this.localCurrentIndex--
        this.$emit('update:currentIndex', this.localCurrentIndex)
        this.loadCurrentNotify()
      }
    },
    handleClose() {
      this.detail = null
      this.localCurrentIndex = 0
      this.$emit('close')
    },
    formatDate(date) {
      if (!date) return '-'
      const d = new Date(date)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    },
    formatDateTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      const seconds = String(d.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style lang="scss" scoped>
.notify-content {
  height: 400px;
  padding: 25px 25px 30px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  overflow-y: auto;

  h2 {
    color: #222;
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 15px;
  }

  ::v-deep img {
    max-width: 100%;
  }

  ::v-deep table.stock-alert-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 12px;

    th, td {
      border: 1px solid #ebeef5;
      padding: 8px 10px;
      text-align: left;
    }

    th {
      background: #f5f7fa;
      font-weight: 600;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
